import { apiService, fetchingAPI } from '@/api'
import { setLoading, setData } from './emails.redux'

export const fetchUploadEmails = (values) => async (dispatch) => {
  const formData = new FormData()
  formData.append('agent_id', values.agent_id)
  values.files.forEach((file) => {
    formData.append('files', file)
  })
  dispatch(setLoading({ emailUpload: true }))
  try {
    // not setting the content type, bc form data needs boundary which is generated automatically

    const emails = await fetchingAPI(
      `${apiService.messageIngestion}/email-ingestion/upload-email-files?organization_id=${values.organization}`,
      'POST',
      dispatch,
      formData,
      undefined,
      undefined,
      undefined,
      undefined,
      false
    )
    const [savedEmails, errors] = emails
    // they should all have the same thread id
    dispatch(
      setData({
        emails: savedEmails,
        isUploadComplete: true,
        errors,
      })
    )

    // Scoring is now handled automatically on the backend after upload
  } catch (err) {
    console.error(err)
    dispatch(setData({ isUploadComplete: true }))
  } finally {
    dispatch(setLoading({ emailUpload: false }))
  }
}
